import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ModalComponent } from '@app/shared/components';
import { Tool } from '@app/tool/model/tool.model';
import { ToolSet } from '@app/tool/model/toolSet.model';

@Component({
  selector: 'app-tool-document-generation-modal',
  templateUrl: './tool-document-generation-modal.component.html',
  styleUrls: ['./tool-document-generation-modal.component.scss']
})
export class ToolDocumentGenerationModalComponent {
  @ViewChild(ModalComponent, { static: false }) modal: ModalComponent;

  @Input() isLoading = false;
  @Output() generateDocuments = new EventEmitter<number[]>();

  selectedTools: Array<Tool | ToolSet> = [];

  open(tools: Array<Tool | ToolSet> = []) {
    this.selectedTools = tools;
    this.modal.open();
  }

  close() {
    this.modal.close();
    this.selectedTools = [];
  }

  confirm() {
    this.generateDocuments.emit(this.getToolIds());
  }

  get tools(): Tool[] {
    return this.selectedTools.reduce((tools: Tool[], selectedTool: Tool | ToolSet) => {
      if (selectedTool instanceof ToolSet) {
        return tools.concat(selectedTool.tools || []);
      }

      return tools.concat(selectedTool as Tool);
    }, []);
  }

  private getToolIds(): number[] {
    return this.tools.map(tool => tool.id);
  }
}
